import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { FormControl } from '@angular/forms';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { FetchMyRunningModules, FetchMyRunningModulesSuccess } from 'app/library/my-running-modules/actions';
import { TagMultiSelectService } from 'app/library/tag/services/multi-select.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, take } from 'rxjs/operators';
import { ModuleUserExtended } from '../../../module-user/models/module-user.extended.model';

export class RunningModuleDataSource implements DataSource<ModuleUserExtended> {
    statusCtrl = new FormControl({ value: '', disabled: false });

    private _loadingSubject = new BehaviorSubject<boolean>(false);

    public loading$ = this._loadingSubject.asObservable();

    constructor(
        private _filteredModule$: Observable<ModuleUserExtended[]>,
        private _store: Store,
        private _action$: Actions,
        public tagMultiSelectService: TagMultiSelectService
    ) {}

    connect(collectionViewer: CollectionViewer): Observable<ModuleUserExtended[]> {
        return this._filteredModule$;
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this._loadingSubject.complete();
    }

    loadModules(category: string, search?: string, sortBy?: string, sortOrder?: string, pageSize?: number, pageNumber?: number, participantId?: string, tag?: number[]): void {
        this._loadingSubject.next(true);
        this._store.dispatch(
            new FetchMyRunningModules({
                category,
                search,
                sortBy,
                sortOrder,
                pageSize,
                pageNumber,
                participantId,
                tag,
            })
        );
        this._action$
            .pipe(
                ofActionDispatched(FetchMyRunningModulesSuccess),
                finalize(() => this._loadingSubject.next(false)),
                take(1)
            )
            .subscribe();
    }
}
